package gr.tech.GRAttestation.models.stores

import kotlinx.serialization.Serializable

@Serializable
data class StoreDTO(
    val id: Int,
    val locationId: String,
    val storeName: String,
    val storeRep: String,
    val createdAt: String,
    val createdBy: String,
    val updatedAt: String,
    val status: Short,
    val storeAddress: String,
    val storeCity: String,
    val storeState: String,
    val storeZip: String,
)

val blankStoreDTO = StoreDTO(
    id = -1,
    locationId = "",
    storeName = "",
    storeRep = "",
    createdAt = "",
    createdBy = "",
    updatedAt = "",
    status = 0,
    storeAddress = "",
    storeCity = "",
    storeState = "",
    storeZip = ""
)